import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function EmployerLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr('');
        try {
            const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
                body: JSON.stringify({ email, password })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Login failed');

            // Check if user is actually an employer
            if (data.user.role !== 'employer' && data.user.role !== 'admin') {
                throw new Error('This login is for employers only. Please use the candidate login.');
            }

            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));

            if (data.user.role === 'admin') {
                navigate('/admin');
            } else {
                navigate('/employer');
            }
            window.location.reload();
        } catch (err) {
            setErr(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-light flex items-center justify-center relative overflow-hidden px-4 pt-20">
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-secondary/5 rounded-full blur-[120px]" />
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-blue-500/5 rounded-full blur-[120px]" />
            </div>

            <div className="max-w-md w-full relative z-10">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-dark mb-2">Employer Login</h2>
                    <p className="text-body">Manage your job postings and find the best talent.</p>
                </div>

                <div className="bg-white rounded-3xl p-8 md:p-10 shadow-card border border-gray-100 relative overflow-hidden">
                    <form onSubmit={submit} className="space-y-6 relative z-10">
                        <div>
                            <label className="block text-sm font-bold text-dark mb-2">Work Email Address</label>
                            <input
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="hr@company.com"
                                className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:ring-4 focus:ring-secondary/10 focus:border-secondary outline-none transition-all hover:bg-white"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-dark mb-2">Password</label>
                            <input
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="••••••••"
                                type="password"
                                className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl text-dark placeholder-gray-400 focus:ring-4 focus:ring-secondary/10 focus:border-secondary outline-none transition-all hover:bg-white"
                            />
                        </div>

                        {err && <div className="p-4 bg-red-50 border border-red-100 rounded-xl text-red-500 text-sm text-center font-bold">{err}</div>}

                        <button
                            type="submit"
                            className="w-full py-4 bg-secondary text-white font-bold rounded-xl hover:bg-blue-900 transition-all shadow-lg shadow-secondary/20 hover:-translate-y-1"
                        >
                            Sign In as Employer
                        </button>
                    </form>

                    <div className="mt-8 text-center relative z-10 border-t border-gray-100 pt-8">
                        <p className="text-body text-sm font-medium mb-2">
                            New to Konnectt Hiring?{' '}
                            <Link to="/employer/register" className="text-secondary font-bold hover:underline transition-colors">
                                Create Employer Account
                            </Link>
                        </p>
                        <p className="text-body text-xs">
                            Are you a job seeker? <Link to="/login" className="text-primary font-bold hover:underline">Candidate Login</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
